"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSectionsListStyles = exports.getSectionStyles = exports.getDefaults = exports.BASE_FONT_SIZE = void 0;

var _sectionsDefaults = _interopRequireDefault(require("./sectionsDefaults"));

var _TemplatesConfig = _interopRequireDefault(require("../TemplatesConfig"));

var _underscore = _interopRequireDefault(require("underscore"));

var _excluded = ["_elements"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BASE_FONT_SIZE = 18;
exports.BASE_FONT_SIZE = BASE_FONT_SIZE;
var settingsProperties = ['spaceTop', 'spaceBottom'];
var fonts = [];
var sectionCustomizationRuleTemplate = {
  spaceTop: [{
    selector: '& .custom-space-top',
    property: 'padding-top'
  }],
  spaceBottom: [{
    selector: '& .custom-space-bottom',
    property: 'padding-bottom'
  }]
};

var skipNullProperties = function skipNullProperties(obj) {
  return Object.keys(obj || {}).reduce(function (res, key) {
    var val = obj[key];

    if (val !== null && val !== undefined) {
      res[key] = val;
    }

    return res;
  }, {});
};

var getSectionSettings = function getSectionSettings(_ref) {
  var _ref$customization = _ref.customization,
      customization = _ref$customization === void 0 ? {} : _ref$customization,
      type = _ref.type,
      template = _ref.template,
      elements = _ref.elements;
  var customizationWithoutNulls = skipNullProperties(customization);

  var _getDefaults = getDefaults({
    type: type,
    template: template
  }),
      elementsDefaults = _getDefaults._elements,
      sectionDefaults = _objectWithoutProperties(_getDefaults, _excluded);

  var settings = _objectSpread(_objectSpread(_objectSpread({}, sectionDefaults), customizationWithoutNulls), {}, {
    _elements: mergeElementsSettings(elementsDefaults, elementsFlatten(elements))
  });

  return settings;
};

var mergeElementsSettings = function mergeElementsSettings() {
  var elementsDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var elements = arguments.length > 1 ? arguments[1] : undefined;
  return (0, _underscore.default)(elements).chain().map(function (element) {
    var customization = element.customization,
        type = element.type;
    var customizationWithoutNulls = skipNullProperties(customization);
    var elemDefaults = elementsDefaults[type] || {};
    return [element.id, _objectSpread(_objectSpread({}, elemDefaults), customizationWithoutNulls)];
  }).object().value();
};

var compactCssRules = function compactCssRules(cssRulesList) {
  return (0, _underscore.default)(cssRulesList).chain().groupBy('selector').pairs().map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        selector = _ref3[0],
        rules = _ref3[1];

    return [selector, (0, _underscore.default)(rules).map('property')];
  }).value();
};

var renderStyle = function renderStyle(compactedRules) {
  return compactedRules.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        selector = _ref5[0],
        properties = _ref5[1];

    return "".concat(selector, " { ").concat(properties.join(' '), " }");
  }).join('\n');
};

var getSectionClassSelector = function getSectionClassSelector(uniq) {
  return ".section-".concat(uniq);
};

var buildSectionRules = function buildSectionRules(_ref6, settings) {
  var type = _ref6.type,
      template = _ref6.template,
      id = _ref6.id,
      rootKey = _ref6.rootKey;
  var ruleTemplatesWithValues = settingsProperties // eslint-disable-next-line no-prototype-builtins
  .filter(function (propName) {
    return settings.hasOwnProperty(propName);
  }).map(function (propName) {
    return [sectionCustomizationRuleTemplate[propName], settings[propName]];
  });
  var renderedRules = ruleTemplatesWithValues.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        ruleTemplatesList = _ref8[0],
        value = _ref8[1];

    return ruleTemplatesList.map(function (_ref9) {
      var selector = _ref9.selector,
          property = _ref9.property;
      return {
        selector: selector.replace('&', getSectionClassSelector(rootKey)),
        property: "".concat(property, ": ").concat(value, "px;")
      };
    });
  });

  var flatRenderedRules = _underscore.default.flatten(renderedRules);

  return compactCssRules(flatRenderedRules);
};

var getSectionsListStyles = function getSectionsListStyles() {
  var sectionsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var renderPreview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var themes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var availableFonts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  fonts = availableFonts;
  var retVal = [];
  sectionsList.forEach(function (section) {
    retVal.push(getSectionStyles(section));

    if (renderPreview) {
      var previewThemes = themes[section.type] || _TemplatesConfig.default.templates.filter(function (t) {
        return !t.hidden;
      }).map(function (_ref10) {
        var name = _ref10.name;
        return name;
      });

      previewThemes.forEach(function (name) {
        var previewSection = _objectSpread(_objectSpread({}, section), {}, {
          rootKey: "".concat(section.rootKey, "-").concat(name),
          template: name
        });

        retVal.push(getSectionStyles(previewSection));
      });

      var previewSection = _objectSpread(_objectSpread({}, section), {}, {
        rootKey: "".concat(section.rootKey, "-").concat(section.template)
      });

      retVal.push(getSectionStyles(previewSection));
    }
  });
  return retVal.filter(function (style) {
    return style && style.length;
  }).join('\n');
};

exports.getSectionsListStyles = getSectionsListStyles;

var getSectionStyles = function getSectionStyles(section) {
  var settings = getSectionSettings(section);
  var rules = buildSectionRules(section, settings);
  var elementRules = section.elements ? getElementsListRules(section.elements, settings._elements, section.rootKey) : [];
  return renderStyle(rules.concat(elementRules));
};

exports.getSectionStyles = getSectionStyles;

var getDefaults = function getDefaults(section) {
  var type = section.type,
      template = section.template;
  var _sectionsDefaults$tem = _sectionsDefaults.default[template];
  _sectionsDefaults$tem = _sectionsDefaults$tem === void 0 ? {} : _sectionsDefaults$tem;
  var settings = _sectionsDefaults$tem[type],
      _sectionsDefaults$com = _sectionsDefaults.default.common;
  _sectionsDefaults$com = _sectionsDefaults$com === void 0 ? {} : _sectionsDefaults$com;
  var _sectionsDefaults$com2 = _sectionsDefaults$com[type],
      commonSettings = _sectionsDefaults$com2 === void 0 ? {} : _sectionsDefaults$com2;
  return settings || commonSettings;
}; // ---


exports.getDefaults = getDefaults;

var elementsFlatten = function elementsFlatten(elements) {
  return (0, _underscore.default)(elements).chain().map(function (el) {
    if (el.id) {
      return el;
    } else {
      return (el.entities || []).concat(el.elements || []);
    }
  }).flatten().value();
};

var getElementsListRules = function getElementsListRules(elements, elementSettings, sectionRootKey) {
  return elementsFlatten(elements).map(function (element) {
    return getElementRule(element, elementSettings[element.id], sectionRootKey);
  }).filter(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        properties = _ref12[1];

    return properties.length;
  });
};

var numericProperty = function numericProperty(propertName) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  return function (value) {
    var floatValue = parseFloat(value, 10);

    if (!floatValue) {
      return null;
    }

    return "".concat(propertName, ": ").concat(floatValue).concat(unit, ";");
  };
};

var getElementStyleProperty = {
  fontId: function fontId(value) {
    var font = fonts.find(function (font) {
      return font.id === value;
    });

    if (!font) {
      return null;
    }

    return "font-family: ".concat(font.cssName, ";");
  },
  fontItalic: function fontItalic(value) {
    if (value === true) {
      return 'font-style: italic;';
    }

    if (value === false) {
      return 'font-style: normal;';
    }

    return null;
  },
  fontBold: function fontBold(value) {
    if (value === true) {
      return 'font-weight: bold;';
    }

    if (value === false) {
      return 'font-weight: normal;';
    }

    return null;
  },
  fontUnderline: function fontUnderline(value) {
    if (value === true) {
      return 'text-decoration: underline;';
    }

    if (value === false) {
      return 'text-decoration: none;';
    }

    return null;
  },
  letterSpacing: numericProperty('letter-spacing'),
  topSpacing: numericProperty('margin-top'),
  bottomSpacing: numericProperty('margin-bottom'),
  lineHeight: numericProperty('line-height'),
  width: numericProperty('width'),
  height: numericProperty('height'),
  borderWidth: numericProperty('border-width'),
  borderRadius: numericProperty('border-radius'),
  fontSize: function fontSize(value) {
    var floatValue = parseFloat(value, 10);

    if (!floatValue) {
      return null;
    }

    var remFontSize = Math.round(100 * (floatValue / BASE_FONT_SIZE)) / 100;
    return "font-size: ".concat(remFontSize, "rem;");
  },
  backgroundSize: function backgroundSize(value) {
    return "background-size: ".concat(value, ";");
  },
  backgroundRepeat: function backgroundRepeat(value) {
    return "background-repeat: ".concat(value, ";");
  },
  backgroundPosition: function backgroundPosition(value) {
    return "background-position: ".concat(value, ";");
  },
  backgroundAttachment: function backgroundAttachment(value) {
    return "background-attachment: ".concat(value, ";");
  }
};

var getElementStyleProperties = function getElementStyleProperties(elementCustomization) {
  return Object.keys(elementCustomization).map(function (key) {
    return (// eslint-disable-next-line no-prototype-builtins
      getElementStyleProperty.hasOwnProperty(key) && getElementStyleProperty[key](elementCustomization[key])
    );
  }).filter(function (prop) {
    return prop;
  });
};

var getElementRule = function getElementRule(element) {
  var elementSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sectionRootKey = arguments.length > 2 ? arguments[2] : undefined;
  var selector = [".section-".concat(sectionRootKey, " .element-").concat(element.rootKey), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey), ".section-".concat(sectionRootKey, " a.element-").concat(element.rootKey), ".section-".concat(sectionRootKey, " p.element-").concat(element.rootKey), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " p"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h1"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h2"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h3"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h4"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h5"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " h6"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " .btn"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " .btn.btn-register"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, " .custom-font"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, ".count-number"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, ".cover-photo-background"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, ".global-cover-photo-background"), ".section-".concat(sectionRootKey, " .element-").concat(element.rootKey, ".cover-image-background")].join(',');
  var properties = getElementStyleProperties(elementSettings || {});
  return [selector, properties];
};